import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ParameterInput from "enterprise/parameters/components/ParameterInput";
const ParameterInputRow = styled.div`
  &:first-child {
    margin-top: 10px;
  }

  .form-group {
    display: flex;
    align-items: baseline;
  }
`;
const ReportParameters = ({ parameters, parameterValues, onChange, parameterSearchIds }) => {
  const { t } = useTranslation("enterprise_report");
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("report_parameters.required_parameters")), /* @__PURE__ */ React.createElement("dd", null, parameters.length === 0 && t("report_parameters.no_widgets_with_parameters"), parameters.map((parameter) => /* @__PURE__ */ React.createElement(ParameterInputRow, { key: parameter.name }, /* @__PURE__ */ React.createElement(
    ParameterInput,
    {
      parameter,
      searchId: parameterSearchIds[parameter.name],
      value: parameterValues[parameter.name],
      onChange
    }
  )))));
};
export default ReportParameters;
